"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var furnitureBuilder = function furnitureBuilder(_a) {
  var _b;

  var _c = _a.furniture,
      furniture = _c === void 0 ? [] : _c;

  if (furniture.length === 0 || furniture.includes(_SearchFilters.FurnitureValue.FURNISHED) && furniture.includes(_SearchFilters.FurnitureValue.UNFURNISHED)) {
    return '';
  }

  return (_b = {}, _b[_SearchFilters.FurnitureValue.FURNISHED] = 'facility_bedroom_furnished:yes', _b[_SearchFilters.FurnitureValue.UNFURNISHED] = 'facility_bedroom_furnished:no', _b)[furniture[0]];
};

var _default = furnitureBuilder;
exports["default"] = _default;